export default "<h1>Redirecionando...</h1>"